"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Auth_1 = __importDefault(require("./Auth"));
function install(Vue, options) {
    const auth = new Auth_1.default(options);
    Vue.prototype.$auth = auth;
}
exports.default = install;
